//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import { ref, onMounted } from '@vue/composition-api'
import { mdiDeleteForever } from '@mdi/js'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import videojs from 'video.js'

export default {
  setup() {
    const myVideo1 = ref(null)

    const { t } = useUtils()

    const refVideoPlayer = ref(null)
    const playerOptions = ref({
      controls: false,
      responsive: true,
      breakpoints: true,
      fill: true,
      autoplay: true,
      muted: true,
      loop: true,
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [],
      poster: themeConfig.app.logo,
      notSupportedMessage: 'Este video no está disponible temporalmente, intente nuevamente más tarde.',
      usingPlugin: true,
      fluid: true,
      aspectRatio: '16:9',
    })

    onMounted(async () => {
      const player = videojs('myVideo1')
      player.play()

      playerOptions.value.sources.push({
        type: 'video/mp4',
        src: 'https://static.smartisanos.cn/common/video/smartisan-tnt-jianguo.mp4',
      })
    })

    return {
      // data
      refVideoPlayer,
      playerOptions,
      myVideo1,

      // themeConfig
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      // i18n
      t,

      icons: {
        mdiDeleteForever,
      },
    }
  },
}
